import React from 'react'
import Button from 'components/shared/Button'

import './index.scss'

const OrderNavigation = ({
  onBack,
  backLabel = 'Gå tilbake',
  backButtonProps = {},
  onNext,
  nextLabel = 'Gå videre',
  nextButtonProps = {},
}) => {
  const hasBackButton = !!onBack || !!Object.keys(backButtonProps).length
  const hasNextButton = !!onNext || !!Object.keys(nextButtonProps).length

  return (
    <div className="order-navigation">
      <div className="back">
        {hasBackButton && (
          <Button
            secondary
            size="large"
            type="navigation"
            onClick={onBack}
            {...backButtonProps}
          >
            {backLabel}
          </Button>
        )}
      </div>

      <div className="next">
        {hasNextButton && (
          <Button
            size="large"
            type="navigation"
            onClick={onNext}
            {...nextButtonProps}
          >
            {nextLabel}
          </Button>
        )}
      </div>
    </div>
  )
}

export default OrderNavigation
